import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { trigger, transition, state, animate, style } from '@angular/animations';

import { HeaderBoxLinksInterface } from '../../interfaces/header-box-links.interface';

@Component({
    selector: 'app-header-box',
    templateUrl: './header-box.component.html',
    styleUrls: ['./header-box.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                overflow: 'hidden'
            })),
            state('closed', style({
                height: '0',
                overflow: 'hidden'
            })),
            transition('open => closed', [
                animate('0.3s')
            ]),
            transition('closed => open', [
                animate('0.3s')
            ])
        ])
    ]
})
export class HeaderBoxComponent implements OnInit {
    public notificationToggled = false;
    public isOpen = false;

    @Input() public toggled: EventEmitter<boolean>;
    @Input() public type: string;
    @Input() public links: HeaderBoxLinksInterface;

    @Output() public logout: EventEmitter<boolean> = new EventEmitter();
    @Output() public changeCategory: EventEmitter<number> = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
        this.toggled.subscribe((result: boolean) => {
            this.isOpen = this.notificationToggled = result;
        });

    }

    onLogoutClick(): void {
        this.logout.emit(true);
    }

    onChangeCagtegoryClicked(field: number): void {
        this.changeCategory.emit(field);
    }
}
